import Box from '@mui/material/Box';
import TabItem from './TabItem';
import { TabPanelProps } from './UserProfileTabs';
import PersonalInfoForm from './PersonalInfoForm';
import { AdminApi } from '../../../services/adminApi';
import { UserProfile } from '../../../global/types/user';

export default function MyAccountTab(props: TabPanelProps) {
  const { value, index, user } = props;

  const handleUpdateProfile = async (updatedUser: Partial<UserProfile>) => {
    if (!user?.id) {
      throw new Error("Usuário não autenticado");
    }
    await AdminApi.updateUserProfile({
      firstName: updatedUser.firstName,
      lastName: updatedUser.lastName,
      email: updatedUser.email,
    });
  };

  const myAccountItemMap = [
    {
      title: "Informações Pessoais",
      description: "Edite ou atualize suas informações pessoais e endereço de e-mail",
      content: <PersonalInfoForm user={user as UserProfile} onUpdate={handleUpdateProfile} />,
    },
    /*{
      title: "Gerenciar Senha e Segurança",
      description: "Acesse o Console de Conta do Keycloak para gerenciar sua senha e configurações de segurança",
      content: <AccountConsoleLink />
    },*/
  ];

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
    >
      {value === index &&
      <Box sx={{ p: 3 }}>
        {myAccountItemMap.map((item, idx) => (
          <TabItem key={idx} {...item}/>
        ))}
      </Box>}
    </div>
  );
}
